// Page view constants
export const BOOKING_INTRO_PAGE_VIEW = "booking_intro_page_view";
export const SCHEDULE_APPOINTMENT_PAGE_VIEW = "schedule_appointment_page_view";
export const TELEMEDICINE_AGREEMENT_PAGE_VIEW =
  "telemedicine_agreement_page_view";
export const THANK_YOU_PAGE_VIEW = "thank_you_page_view";
export const TERMS_AGREEMENT_PAGE_VIEW = "terms_agreement_page_view";
export const PAYMENT_PAGE_VIEW = "payment_page_view";
export const ADDRESS_PAGE_VIEW = "address_page_view";
export const ACCOUNT_CREATE_PAGE_VIEW = "account_create_page_view";

export const ACCOUNT_RECOVERY_PAGE_FROM_EMAIL =
  "account_recovery_page_from_email";

// DeepLinks constants
export const SCHEDULE_APPOINTMENT_LINK_CREATION_FAILED =
  "schedule_appointment_link_creation_failed";
export const PAYMENT_LINK_CREATION_FAILED =
  "payment_method_link_creation_failed";
export const APPOINTMENT_VIDEO_LINK_CREATION_FAILED =
  "appointment_video_link_creation_failed";
export const APPOINTMENT_VIDEO_LINK_NO_CONSULT_FOUND =
  "appointment_video_link_no_consult_found";
export const APPOINTMENT_VIDEO_LINK_TIMEOUT = "appointment_video_link_timeout";
export const APPOINTMENT_CARD_VIEWED = "appointment_card_viewed";
export const APPOINTMENT_CONFIRM_CLICKED = "appointment_confirm_clicked";
export const APPOINTMENT_EDIT_CLICKED = "appointment_edit_clicked";
export const APPOINTMENT_JOIN_CLICKED = "appointment_join_clicked";
export const CREATE_PASSWORD_LINK_CREATION_FAILED =
  "create_password_link_creation_failed";

// Event constants
export const ACCOUNT_CREATION_PAGE_LOAD_FAILURE =
  "account_creation_page_load_failure";

export const APPOINTMENT_SLOTS_VISIBLE = "appointment_slots_visible";
export const ERROR_FETCHING_APPOINTMENT_SLOTS =
  "error_fetching_appointment_slots";
export const USER_SELECTED_APPOINTMENT_SLOT = "user_selected_appointment_slot";
export const APPOINTMENT_BOOKED_SUCCESS = "appointment_booking_success";
export const APPOINTMENT_BOOKED_FAILURE = "appointment_booking_failure";
export const APPOINTMENT_SLOTS_LOAD_STARTED = "appointment_slots_load_started";
export const APPOINTMENT_SLOTS_LOAD_FAILED = "appointment_slots_load_failed";
export const APPOINTMENT_SLOTS_EMPTY = "appointment_slots_empty";
export const APPOINTMENT_SLOTS_RENDER_FAILED =
  "appointment_slots_render_failed";
export const APPOINTMENT_SLOTS_LOAD_TIMEOUT = "appointment_slots_load_timeout";
export const APPOINTMENT_CONFIRMED_PAGE_VIEWED =
  "appointment_confirmed_page_viewed";

// Thank You Page Render Tracking
export const THANK_YOU_PAGE_RENDER_SUCCESS = "thank_you_page_render_success";
export const THANK_YOU_PAGE_LOADING_TIMEOUT = "thank_you_page_loading_timeout";
export const THANK_YOU_PAGE_DATA_LOAD_FAILURE =
  "thank_you_page_data_load_failure";

// Lilly Agreement Events
export const LILLY_AGREEMENT_ACCEPTED = "lilly_agreement_accepted";

// Post-Checkout Handoff Events
export const POST_CHECKOUT_HANDOFF = "post_checkout_handoff";
export const POST_CHECKOUT_HANDOFF_ERROR = "post_checkout_handoff_error";

export const MEDS_RESERVED_SUCCESS = "meds_reserved_success";
export const MEDS_RESERVED_FAILURE = "meds_reserved_failure";

export const CREATE_INTAKE_SUCCESS = "create_intake_success";
export const CREATE_INTAKE_FAILURE = "create_intake_failure";

export const PLAN_PURCHASE_SUCCESS = "plan_purchase_success";
export const PLAN_PURCHASE_FAILURE = "plan_purchase_failure";

export const LOADER_QUESTION_INITIATED = "loader_question_initiated";

export const PORTAL_LOGIN = "portal_login";
export const APP_LOGIN = "app_login";

// Wrong-app entrypoint (FLEX-186)
export const WRONG_APP_ENTRYPOINT_DETECTED = "wrong_app_entrypoint_detected";
export const WRONG_APP_REDIRECT_LINK_CLICKED =
  "wrong_app_redirect_link_clicked";

// SMD migration interception (FLEX-281)
export const MIGRATION_BANNER_VIEWED = "migration_banner_viewed";
export const MIGRATION_BANNER_CTA_CLICKED = "migration_banner_cta_clicked";
export const MIGRATION_FULLPAGE_VIEWED = "migration_fullpage_viewed";
export const MIGRATION_FULLPAGE_CTA_CLICKED = "migration_fullpage_cta_clicked";
export const MIGRATION_FULLPAGE_DISMISSED = "migration_fullpage_dismissed";

// Survey Events

export const SURVEY_STARTED = "survey_started";
export const SURVEY_QUESTION = "survey_question";
export const SURVEY_COMPLETED = "survey_completed";
export const RESULTS_VIEWED = "results_viewed";
export const SURVEY_DISQUALIFIED = "survey_disqualified";

// Payment Events
export const PAYMENT_ELEMENT_SUBMISSION_INITIATED =
  "payment_element_submission_initiated";
export const PAYMENT_ELEMENT_SUBMISSION_SUCCESS =
  "payment_element_submission_success";
export const PAYMENT_ELEMENT_SUBMISSION_ERROR =
  "payment_element_submission_error";
export const STRIPE_EXPRESS_CHECKOUT_INITIATED =
  "stripe_express_checkout_initiated";
export const STRIPE_EXPRESS_CHECKOUT_ERROR = "stripe_express_checkout_error";
export const STRIPE_EXPRESS_CHECKOUT_SUCCESS =
  "stripe_express_checkout_success";
export const GR4VY_CHECKOUT_ATTEMPT = "gr4vy_checkout_attempt";
export const GR4VY_CHECKOUT_INITIATED = "gr4vy_checkout_initiated";
export const GR4VY_CHECKOUT_ERROR = "gr4vy_checkout_error";
export const GR4VY_CHECKOUT_SUCCESS = "gr4vy_checkout_success";

export const GR4VY_APPLEPAY_CHECKOUT_DISPLAYED =
  "gr4vy_applepay_checkout_displayed";
export const GR4VY_APPLEPAY_CHECKOUT_ATTEMPT =
  "gr4vy_applepay_checkout_attempt";
export const GR4VY_APPLEPAY_CHECKOUT_SUCCESS =
  "gr4vy_applepay_checkout_success";
export const GR4VY_APPLEPAY_CHECKOUT_ERROR = "gr4vy_applepay_checkout_error";

export const GR4VY_GOOGLEPAY_CHECKOUT_ATTEMPT =
  "gr4vy_googlepay_checkout_attempt";
export const GR4VY_GOOGLEPAY_CHECKOUT_SUCCESS =
  "gr4vy_googlepay_checkout_success";
export const GR4VY_GOOGLEPAY_CHECKOUT_ERROR = "gr4vy_googlepay_checkout_error";

export const GR4VY_AFFIRM_CHECKOUT_ATTEMPT = "gr4vy_affirm_checkout_attempt";
export const GR4VY_AFFIRM_CHECKOUT_SUCCESS = "gr4vy_affirm_checkout_success";
export const GR4VY_AFFIRM_CHECKOUT_FAILED = "gr4vy_affirm_checkout_failed";
export const GR4VY_AFFIRM_CHECKOUT_ERROR = "gr4vy_affirm_checkout_error";
export const GR4VY_AFFIRM_REDIRECT_TO = "gr4vy_affirm_redirect_to";
export const GR4VY_AFFIRM_REDIRECT_BACK = "gr4vy_affirm_redirect_back";
export const AFFIRM_REJECT_PAGE_VIEW = "affirm_reject_page_view";

// Amazon Modal Events
export const AMAZON_MODAL_REFILL_SCREEN_VIEWED =
  "amazon-modal-refill_screen_viewed";
export const AMAZON_MODAL_REFILL_SCREEN_CLOSED =
  "amazon-modal-refill_screen_closed";
export const AMAZON_MODAL_REFILL_CTA_INTERACTED =
  "amazon-modal-refill_cta_interacted";

export const AMAZON_MODAL_CA_SCREEN_VIEWED = "amazon-modal-CA_screen_viewed";
export const AMAZON_MODAL_CA_SCREEN_CLOSED = "amazon-modal-CA_screen_closed";
export const AMAZON_MODAL_CA_CTA_INTERACTED = "amazon-modal-CA_cta_interacted";

export const CHECKOUT_INSURANCE_SCREEN_VIEWED =
  "checkout-insurance_screen_viewed";
export const CHECKOUT_WEGOVY_SCREEN_VIEWED = "checkout-wegovy_screen_viewed";
export const CHECKOUT_WEGOVY_PILL_SCREEN_VIEWED =
  "checkout-wegovy_pill_screen_viewed";
export const CHECKOUT_ZEPBOUND_SCREEN_VIEWED =
  "checkout-zepbound_screen_viewed";
export const CHECKOUT_MOUNJARO_SCREEN_VIEWED =
  "checkout-mounjaro_screen_viewed";
export const CHECKOUT_OZEMPIC_SCREEN_VIEWED = "checkout-ozempic_screen_viewed";
export const CHECKOUT_SEMAGLUTIDE_SCREEN_VIEWED =
  "checkout-semglutide_screen_viewed";
export const CHECKOUT_SEMAGLUTIDE_PILL_SCREEN_VIEWED =
  "checkout-semglutide_pill_screen_viewed";
export const CHECKOUT_TIRZEPATIDE_SCREEN_VIEWED =
  "checkout-tirzepatide_screen_viewed";
export const CHECKOUT_TIRZEPATIDE_PILL_SCREEN_VIEWED =
  "checkout-tirzepatide_pill_screen_viewed";

// After Visit Summary Events
export const AFTER_VISIT_SUMMARY = "after_visit_summary";
export const VIEW_CLINICIAN_MESSAGES = "view_clinician_messages";
export const CHAT_WINDOW_CONSULT_CHECK_ERROR =
  "chat_window_consult_check_error";
export const CREATE_APPT_NEXT_STEPS_SUCCESS = "create_appt_next_steps_success";
export const CREATE_APPT_NEXT_STEPS_FAILURE = "create_appt_next_steps_failure";
export const USER_PRODUCT_DATA_NOT_FOUND = "user_product_data_not_found";
export const ADD_PAYMENT_METHOD = "add_payment_method";
export const ADD_PAYMENT_METHOD_ERROR = "add_payment_method_error";

// Video Visit Events
export const VIDEO_VISIT_JOINED = "video_visit_joined";
export const VIDEO_VISIT_JOIN_FAILED = "video_visit_join_failed";
export const VIDEO_LINK_CLICKED_FROM_EMAIL = "video_link_clicked_from_email";
export const VIDEO_LINK_OPENED = "video_link_opened";

// Appointment Card Events
export const APPOINTMENT_CARD_SHOWN = "appointment_card_shown";
export const APPOINTMENT_JOIN_NOW_CLICKED = "appointment_join_now_clicked";

// Side Effects Events
export const SIDE_EFFECTS_REPORTED = "side_effects_reported";

// Messages Events
export const MESSAGE_SENT = "message_sent";
export const MESSAGE_ERROR = "message_error";

// Clinic Events
export const CLINIC_SELECTED = "clinic_selected";
export const CLINIC_SEARCH = "clinic_search";

// Payment Method Events
export const LIST_PAYMENT_METHODS_FAILED = "list_payment_methods_failed";
export const ERROR_RETRIEVING_GRAVY_ID = "error_retrieving_gravy_id";
export const SET_CARD_PRIMARY_ERROR = "set_card_primary_error";
export const DELETE_PAYMENT_METHOD = "delete_payment_method";
export const DELETE_PAYMENT_METHOD_ERROR = "delete_payment_method_error";

export const DISQUALIFIED_USER_TRYING_TO_PURCHASE_MEDS =
  "disqualified_user_trying_to_purchase_meds";
// Refill Events
export const REFILL_SCREEN_VIEWED = "refill_screen_viewed";
export const REFILL_FORM_STARTED = "refill_form_started";
export const REFILL_FORM_AVAILABLE = "refill_form_available";
export const REFILL_FORM_START_CLICKED = "refill_form_start_clicked";
export const REFILL_QUESTION_VIEWED = "refill_question_viewed";
export const REFILL_FORM_COMPLETED = "refill_form_completed";
export const DOSE_ESCALATION_CONSENT_VIEWED = "dose_escalation_consent_viewed";
export const DOSE_ESCALATION_CHOICE_SELECTED =
  "dose_escalation_choice_selected";
export const REFILL_COMPLETED_PENDING_PAYMENT =
  "refill_completed_pending_payment";

export const POSTHOG_DISTINCT_ID = "posthog_distinct_id";
export const POSTHOG_SESSION_ID = "posthog_session_id";

// posthog conversion events
export const CONV_LEAD = "conv_lead";
export const CONV_LEAD_VIEW = "conv_lead_view";
export const CONV_LEAD_CTA = "conv_lead_cta";
export const CONV_LEAD_NAME_FOCUS = "conv_lead_name_focus";
export const CONV_LEAD_EMAIL_FOCUS = "conv_lead_email_focus";
export const CONV_LEAD_PHONE_FOCUS = "conv_lead_phone_focus";
export const CONV_ADD_TO_CART = "conv_add_to_cart";
export const CONV_RESULTS_VIEWED = "conv_results_viewed";

// Deactivated-product fallback (shown in place of a deactivated results page)
export const CONV_PRODUCT_UNAVAILABLE_VIEW = "conv_product_unavailable_view";
export const CONV_PRODUCT_UNAVAILABLE_CTA = "conv_product_unavailable_cta";
export const CONV_PHONE_NUMBER_CLICK = "conv_phone_number_click";

// Initial Async Events
export const INITIAL_ASYNC_LANDING_VIEWED = "initial_async_landing_viewed";
export const INITIAL_ASYNC_LANDING_CTA_CLICKED =
  "initial_async_landing_cta_clicked";
export const INITIAL_ASYNC_LANDING_SYNC_APPOINTMENT_CLICKED =
  "initial_async_landing_sync_appointment_clicked";
export const INITIAL_ASYNC_LANDING_BACK_BUTTON_CLICKED =
  "initial_async_landing_back_button_clicked";
export const WELCOME_INITIAL_ASYNC = "welcome_initial_async";

// Async Expectation Events
export const ASYNC_EXPECTATION_SCREEN_VIEWED =
  "async_expectation_screen_viewed";
export const ASYNC_EXPECTATION_CONTINUE_CLICKED =
  "async_expectation_continue_clicked";
// Async Funnel Events
export const ASYNC_SCREEN_VIEWED = "async_screen_viewed";
export const ASYNC_FORM_STARTED = "async_form_started";
export const ASYNC_FORM_COMPLETED = "async_form_completed";
export const ASYNC_FORM_ERROR = "async_form_error";
export const ASYNC_FRONT_VIEW_PHOTO_SAVED_LOCALLY =
  "async_front_view_photo_saved_locally";
export const ASYNC_SIDE_VIEW_PHOTO_SAVED_LOCALLY =
  "async_side_view_photo_saved_locally";
export const ASYNC_GOVERNMENT_ID_PHOTO_SAVED_LOCALLY =
  "async_government_id_photo_saved_locally";

// Async Weight Loss Questions Events
export const ASYNC_TRIED_WEIGHT_LOSS_YES = "async_tried_weight_loss_yes";

// Async Statements Confirmation Events
export const ASYNC_MOON_FACE_CONFIRMATION_ANSWERED =
  "async_moon_face_confirmation_answered";
export const ASYNC_BUFFALO_HUMP_CONFIRMATION_ANSWERED =
  "async_buffalo_hump_confirmation_answered";

// Async Confirmation Events
export const ASYNC_CONFIRMATION_PAGE_VIEW = "async_confirmation_page_view";
export const ASYNC_CONFIRMATION_STARTED = "async_confirmation_started";
export const ASYNC_CONFIRMATION_SUCCESS = "async_confirmation_success";
export const ASYNC_CONFIRMATION_FAILURE = "async_confirmation_failure";
export const ASYNC_CONFIRMATION_COMPLETED = "async_confirmation_completed";
export const ASYNC_CONFIRMATION_ERROR = "async_confirmation_error";
export const ASYNC_CONFIRMATION_MISSING_PARAMS =
  "async_confirmation_missing_params";
export const ASYNC_CONFIRMATION_LOGIN_CLICKED =
  "async_confirmation_login_clicked";
export const ASYNC_CONFIRMATION_VERIFICATION_FAILED =
  "async_confirmation_verification_failed";

// Async Data Retrieval Events
export const ASYNC_SESSION_DATA_RETRIEVED = "async_session_data_retrieved";
export const ASYNC_SESSION_RETRIEVAL_ERROR = "async_session_retrieval_error";
export const ASYNC_ANSWERS_RETRIEVED = "async_answers_retrieved";

// Async Episode Events
export const ASYNC_EPISODE_CREATION_STARTED = "async_episode_creation_started";
export const ASYNC_EPISODE_CREATION_SUCCESS = "async_episode_creation_success";
export const ASYNC_EPISODE_CREATION_ERROR = "async_episode_creation_error";
export const ASYNC_EPISODE_REUSED = "async_episode_reused";
export const ASYNC_EPISODE_CREATION_ORPHANED_RECORDS =
  "async_episode_creation_orphaned_records";

// Async Consult Events
export const ASYNC_CONSULTS_ANALYZED = "async_consults_analyzed";
export const ASYNC_CONSULT_ALREADY_EXISTS = "async_consult_already_exists";
export const ASYNC_CANCELING_NON_ASYNC_CONSULTS =
  "async_canceling_non_async_consults";
export const SYNC_CONSULT_CANCELED = "sync_consult_canceled";
export const ASYNC_CONSULT_CREATION_STARTED = "async_consult_creation_started";
export const ASYNC_CONSULT_CREATION_SUCCESS = "async_consult_creation_success";

// Async Intake Events
export const ASYNC_INTAKE_CREATION_STARTED = "async_intake_creation_started";
export const ASYNC_INTAKE_PHOTO_UPLOAD_STARTED =
  "async_intake_photo_upload_started";
export const ASYNC_INTAKE_PHOTOS_UPLOADED_SUCCESS =
  "async_intake_photos_uploaded_success";
export const ASYNC_INTAKE_NO_PHOTOS_TO_UPLOAD =
  "async_intake_no_photos_to_upload";
export const ASYNC_INTAKE_PHOTO_UPLOAD_ERROR =
  "async_intake_photo_upload_error";
export const ASYNC_INTAKE_FINALIZED = "async_intake_finalized";
export const ASYNC_INTAKE_FINALIZE_ERROR = "async_intake_finalize_error";

// Async Browser Banner Events
export const ASYNC_BROWSER_BANNER_VIEWED = "async_browser_banner_viewed";
export const ASYNC_BROWSER_BANNER_COPY_LINK_CLICKED =
  "async_browser_banner_copy_link_clicked";
export const ASYNC_BROWSER_BANNER_DISMISSED = "async_browser_banner_dismissed";

// Medication Order Card Events
export const MEDICATION_ORDER_CARD_DISPLAYED =
  "medication_order_card_displayed";
export const MEDICATION_ORDER_CARD_VIEWED = "medication_order_card_viewed";
export const MEDICATION_ORDER_CARD_CTA_TAPPED =
  "medication_order_card_cta_tapped";

export const USER_PROFILE_ASYNC_STATUS_UPDATED =
  "user_profile_async_status_updated";
export const USER_PROFILE_UPDATE_ERROR = "user_profile_update_error";

// Async Welcome
export const SEND_ASYNC_WELCOME_EMAIL = "send_async_welcome_email";

// Glide Redirect Events
export const GLIDE_REDIRECT_INITIATED = "glide_redirect_initiated";
export const GLIDE_REDIRECT_ERROR = "glide_redirect_error";

// Self-serve migration events (FLEX-389/MED-2674)
export const SELF_SERVE_MIGRATION_CTA_VIEWED =
  "self_serve_migration_cta_viewed";
export const SELF_SERVE_MIGRATION_PAGE_VIEWED =
  "self_serve_migration_page_viewed";
export const SELF_SERVE_MIGRATION_STARTED = "self_serve_migration_started";
export const SELF_SERVE_MIGRATION_SUCCESS = "self_serve_migration_success";
export const SELF_SERVE_MIGRATION_TIMEOUT = "self_serve_migration_timeout";
export const SELF_SERVE_MIGRATION_ERROR = "self_serve_migration_error";

// Apple Fitness+ Events
export const AF_WIDGET_DISPLAYED = "af_widget_displayed";
export const AF_WIDGET_CTA_TAPPED = "af_widget_cta_tapped";
export const AF_LANDING_PAGE_VIEWED = "af_landing_page_viewed";
export const AF_PRIMARY_CTA_TAPPED = "af_primary_cta_tapped";
export const AF_SECONDARY_CTA_TAPPED = "af_secondary_cta_tapped";
